/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerFindOneQueryResponse, NotificationEmailDeliveriesControllerFindOnePathParams, NotificationEmailDeliveriesControllerFindOneQueryParams, NotificationEmailDeliveriesControllerFindOne400, NotificationEmailDeliveriesControllerFindOne401, NotificationEmailDeliveriesControllerFindOne403, NotificationEmailDeliveriesControllerFindOne404 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationEmailDeliveriesControllerFindOne } from "../../clients/notification-email-deliveriesService/notificationEmailDeliveriesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationEmailDeliveriesControllerFindOneQueryKey = (id: NotificationEmailDeliveriesControllerFindOnePathParams["id"], params: NotificationEmailDeliveriesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/notification-email-deliveries/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type NotificationEmailDeliveriesControllerFindOneQueryKey = ReturnType<typeof notificationEmailDeliveriesControllerFindOneQueryKey>;
export function notificationEmailDeliveriesControllerFindOneQueryOptions(id: NotificationEmailDeliveriesControllerFindOnePathParams["id"], params?: NotificationEmailDeliveriesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationEmailDeliveriesControllerFindOneQueryKey(id, params);
  return queryOptions<NotificationEmailDeliveriesControllerFindOneQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindOne400 | NotificationEmailDeliveriesControllerFindOne401 | NotificationEmailDeliveriesControllerFindOne403 | NotificationEmailDeliveriesControllerFindOne404>, NotificationEmailDeliveriesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationEmailDeliveriesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get one notification email delivery
 * {@link /api/v1/notification-email-deliveries/:id}
 */
export function useNotificationEmailDeliveriesControllerFindOne<TData = NotificationEmailDeliveriesControllerFindOneQueryResponse, TQueryData = NotificationEmailDeliveriesControllerFindOneQueryResponse, TQueryKey extends QueryKey = NotificationEmailDeliveriesControllerFindOneQueryKey>(id: NotificationEmailDeliveriesControllerFindOnePathParams["id"], params?: NotificationEmailDeliveriesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<NotificationEmailDeliveriesControllerFindOneQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindOne400 | NotificationEmailDeliveriesControllerFindOne401 | NotificationEmailDeliveriesControllerFindOne403 | NotificationEmailDeliveriesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationEmailDeliveriesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...notificationEmailDeliveriesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindOne400 | NotificationEmailDeliveriesControllerFindOne401 | NotificationEmailDeliveriesControllerFindOne403 | NotificationEmailDeliveriesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}